export default __webpack_public_path__ + "static/media/fasad8.00864586.jpeg";